export class DsoDetails{

    _prm : string;
    _ean : string;
    _city : string;
    _postCode : string;
    _address:string;
    _name:string;

    constructor( prm : string, ean: string, city : string, postCode :string, address :string, name : string) {
        this._prm = prm;
        this._ean = ean;
        this._city=city;
        this._postCode = postCode;
        this._address = address
        this._name = name
    }
    serialize() {
        return {
            prm: this._prm,
            ean: this._ean,
            city:this._city,
            postCode : this._postCode,
            address:this._address,
            name:this._name
        }
    }

}
